import { ConfigState } from 'store/config/types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const configSelector = (state: RootState): ConfigState => state.config;

export const selectLocale = createSelector(configSelector, (state: ConfigState): string => state.locale || 'en');

export const hasToken = createSelector(configSelector, ({ authToken }: RootState['config']): boolean => !!authToken);
